{
     
    "changeYourPassword": "Change your Password",
    "enterPassword":"Please enter and confirm a new password. Remember that passwords are case-sensitive",
    "currentPassword": "Current Password",
    "password": "Password",
    "confirmation": "Confirmation",
    "update": "Update",
    "cancel": "Cancel",
    "oldPassword": "Old Password",
    "newPassword": "New Password",
    "warningMessage": "Password must contain one lower case and upper case alpha character, one special character, one digit, and be at least 8 characters long.",
    "passwordChangeSuccessfull": "Your password has been changed.You must log in using your new password.",
    "ok": "OK"
}